import React from 'react';

const Takeaways = () => {
  const takeawayItems = [
    {
      icon: "fa-solid fa-file-lines",
      title: "AI Prompt Pack for HR Leaders",
      description: "10 ready-to-use prompts for HR use cases"
    },
    {
      icon: "fa-solid fa-map",
      title: "Tool Map",
      description: "When to use ChatGPT, Claude, Gemini, Perplexity, and Gamma"
    },
    {
      icon: "fa-solid fa-rocket",
      title: "Quick-Start Guide",
      description: "Do's, don'ts, and privacy guardrails for AI in HR"
    },
    {
      icon: "fa-solid fa-award",
      title: "Certificate of Participation",
      description: "Optional, if you want to boost perceived value"
    }
  ];

  return (
    <section className="takeaways">
      <div className="container">
        <h2 className="section-title">What You'll Take Away</h2>
        <div className="takeaways-grid">
          {takeawayItems.map((item, index) => (
            <div key={index} className="takeaway-item">
              <div className="icon-wrap">
                <i className={item.icon}></i>
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Takeaways;
